import { faker } from '@faker-js/faker'

import { PaymentRewardPointRule, PointBalance } from '../../contracts/point'

export const createRandomPointBalance = (overrides?: Partial<PointBalance>): PointBalance => {
  return {
    balance: faker.number.int(),
    ...overrides,
  }
}

export const createRandomPaymentRewardPointRule = (
  overrides?: Partial<PaymentRewardPointRule>,
): PaymentRewardPointRule => {
  return {
    toBeRewardedPoints: {
      currency: faker.helpers.arrayElement(['KRW', 'JPY']),
      amount: faker.number.int(),
    },
    rule: {
      currency: faker.helpers.arrayElement(['KRW', 'JPY']),
      minAmount: faker.number.int(),
      maxAmount: faker.number.int(),
      label: faker.lorem.word(),
      detail: [faker.lorem.sentence()],
    },
    ...overrides,
  }
}
